var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('div',{staticClass:"relative pt-6 pb-3 sm:pb-4 md:pb-6 lg:pb-10 xl:pb-12",attrs:{"id":"home"}},[_c('Header'),_c('Hero')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }